import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchBlueprintVersionedGroupsArgs } from "types/generated";

type CheckTemplatesData = {
  searchBlueprintVersionedGroups: {
    edges: Array<{
      node: {
        id: string;
      };
    }>;
  };
};

export const CHECK_TEMPLATES: TypedDocumentNode<
  CheckTemplatesData,
  QuerySearchBlueprintVersionedGroupsArgs
> = gql`
  query CheckTemplates {
    searchBlueprintVersionedGroups(input: { first: 1 }) {
      edges {
        node {
          id
        }
      }
    }
  }
`;
